import React, { useMemo, useEffect } from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { Select, Spin } from "antd";
import { useQuery } from "react-query";
import useAxiosInstance from "../../../../lib/useAxiosInstance";
import { useTranslation } from "react-i18next";


const CATEGORY_COLORS = {
  Safe: "#2ecc71",
  Favourable: "#27ae60",
  BattleGround: "#f1c40f",
  Difficult: "#e67e22",
  "Very Difficult": "#e74c3c",
};

const Favourability = ({ data = [], loading, party, onPartyChange,surveyId }) => {
  const { t } = useTranslation();
  const axiosInstance=useAxiosInstance();

  //   /* ---------------- FETCH PARTIES ---------------- */

  // const { data: parties = [], isLoading: partiesLoading } = useQuery({
  //   queryKey: ["parties", surveyId],
  //   enabled: !!surveyId,
  //   refetchOnWindowFocus: false,
  //   retry: 1,
  //   queryFn: async () => {
  //     const res = await axiosInstance.get(
  //       `/api/electionData/parties/${surveyId}`
  //     );
  //     return res?.data?.data || [];
  //   },
  // });

  /* ---------------- SET DEFAULT PARTY ---------------- */

  // useEffect(() => {
  //   if (!party && parties.length > 0) {
  //     onPartyChange(parties[0]);
  //   }
  // }, [parties, party, onPartyChange]);

  const pieData = useMemo(() => {
    const counts = {};
    data.forEach((v) => {
      counts[v.category] = (counts[v.category] || 0) + 1;
    });

    const total = Object.values(counts).reduce((a, b) => a + b, 0);

    return Object.keys(counts).map((key) => ({
      name: key,
      value: Math.round((counts[key] / total) * 100),
      color: CATEGORY_COLORS[key],
    }));
  }, [data]);

   if (loading) {
    return (
      <div className="flex justify-center items-center h-40">
        <Spin size="large" />
      </div>
    );
  }
  return (
    <div className="absolute top-[25%] right-2 p-1 card-wrapper !rounded-xl w-[320px] z-[20]">
        <h3 className="text-lg font-semibold text-center text-[#123865] mb-1">
        {t("winningProbabilityDistribution")}
      </h3>
      {/* PARTY SELECT */}
      {/* <Select
        placeholder="Select Party"
        value={party}
        onChange={onPartyChange}
        options={parties.map((p) => ({
          value: p,
          label: p,
        }))}
        getPopupContainer={(trigger) => trigger.parentNode}
        className="mb-3 rounded-full"
        showSearch
      /> */}
      {/* <div className="mt-1 mb-1 flex justify-start">
          <select
            className="rounded-full border px-2 !py-1 text-xs text-black card-wrapper"
            value={party}
            onChange={(e) => onPartyChange(e.target.value)}
          >
            {parties.map((p) => (
              <option key={p} value={p}>
                {p}
              </option>
            ))}
          </select>
        </div> */}

      {/* PIE CHART */}
      <ResponsiveContainer width="100%" height={260}>
        <PieChart>
          <Pie
            data={pieData}
            dataKey="value"
            nameKey="name"
            innerRadius={60}
            outerRadius={100}
            label={({ value }) => `${value}%`}
          >
            {pieData.map((entry, index) => (
              <Cell key={index} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip formatter={(val) => `${val}%`} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Favourability;
